import React from 'react';
import ProfileMenu from './ProfileMenu';
import { FaBars } from 'react-icons/fa';
import PreferenceControls from './Home/ReusableComponents/PreferenceControls';


const Header = ({ handleToggleSidebar,handleCollapsedChange,toggled,
    collapsed }) => {


    const marginLeft = (toggled==false || window.innerWidth<=768)?0:(collapsed==false?270:80);
    return (
        <div className="topbar hidethis modern-topbar">

           

            <nav className="navbar-custom modern-navbar d-flex justify-content-between align-items-center" style={{marginLeft: marginLeft,transition: 'all 0.3s '}}>
            <div className="btn-toggle modern-menu-toggle" onClick={() => {
                    if(window.innerWidth<=768){
                        handleToggleSidebar(!toggled)

                    }
                    else{
                        handleCollapsedChange(!collapsed)

                    }
                }}>
                    <FaBars />
                </div>
                <ul className="navbar-right header-controls d-flex list-inline float-right mb-0">
                    <li className="list-inline-item">
                        <PreferenceControls compact />
                    </li>
                    <ProfileMenu />


                </ul>



            </nav>
        </div>

    );

}


export default Header;
